import { Component, OnInit , Input, Output, EventEmitter} from '@angular/core';

@Component({
  selector: 'app-boxusuariosala',
  templateUrl: './boxusuariosala.component.html',
  styleUrls: ['./boxusuariosala.component.css']
})
export class BoxusuariosalaComponent implements OnInit {
  @Output() itemDetail = new EventEmitter<any[]>();
  @Input() item;
  @Input() salaTransfer;
  nombre = '';
  constructor() {}

  ngOnInit(): void {
    this.nombre = this.item.participant_alias;
  }
  reportChange() {
    //Recepcion_youforget
    this.itemDetail.emit(this.item);
  }
  trasnferir() {
    let id = this.item.id;
    const dataTrans = {
      participant_id: id,
      conference_alias: this.salaTransfer,
      role: 'guest',
    };
    const url =
      'https://us-central1-youforget-ewink.cloudfunctions.net/app/Transferencia';
    fetch(url, {
      method: 'POST',
      body: JSON.stringify(dataTrans),
    }).then((res) => {
      this.reportChange();
    });
  }

  desconectar(){
    let id = this.item.id;
    const dataTrans = {
      participant_id: id,
    };
    const url =
      'https://us-central1-youforget-ewink.cloudfunctions.net/app/disconnect';
    fetch(url, {
      method: 'POST',
      body: JSON.stringify(dataTrans),
    }).then((res) => {
      this.reportChange();
    });
  }

}
